{
  "(disabled)": "[inaktiv]",
  "Add": "Lägg till",
  "All": "Alla",
  "Actions": "Actions",
  "Approve": "Godkänn",
  "Archived": "Arkiverade",
  "Back": "Tillbaka",
  "Both": "Båda",
  "Cancel": "Avbryt",
  "Close": "Stäng",
  "Clear": "Rensa",
  "Complete": "Färdig",
  "Confirm": "Bekräfta",
  "Confirmation": "Bekräftelse",
  "Content": "Content",
  "Continue": "Gå vidare",
  "Create": "Skapa",
  "Date": "Datum",
  "Delete": "Ta bort",
  "Description": "Beskrivning",
  "Download CSV": "Ladda ner CSV",
  "Download": "Ladda ner",
  "Edit": "Redigera",
  "Error": "Fel",
  "Exit": "Stäng",
  "Email": "E-post",
  "Status": "Status",
  "End date": "Slutdatum",
  "Finish": "Klar",
  "Format": "Format",
  "generic-error-reload-page": "Ett fel uppstod. Ladda om sidan och försök igen eller kontakta support på <0>support@collegial.com</0>",
  "404-message": "Något gick fel. Du kan gå <1><0>TILLBAKA</0></1> eller kontakta <3><0>SUPPORT</0></3>",
  "404-archived-message": "Det här lärandet har blivit arkiverat och är inte längre tillgängligt. Du kan gå <1><0>TILLBAKA</0></1>",
  "404-go-to-start-page": "Gå till startsidan",
  "404-page-not-found": "Sidan hittades inte",
  "404-page-archived": "Lärande arkiverat",
  "Hidden": "Dold",
  "ID": "ID",
  "Import": "Import",
  "Language": "Språk",
  "Loading...": "Laddar...",
  "Location": "Plats",
  "Mandatory": "Obligatorisk",
  "Name": "Namn",
  "New": "Ny",
  "Next": "Nästa",
  "No": "Nej",
  "No data": "Ingen data",
  "Not started": "Inte påbörjad",
  "Ongoing": "Pågående",
  "Preview": "Förhandsgranska",
  "Previous": "Tidigare",
  "Realm": "Realm",
  "Remove": "Ta bort",
  "Restore": "Återställ",
  "Save": "Spara",
  "Change": "Change",
  "Search": "Sök",
  "Selected {{count}}/{{total}}": "{{count}}/{{total}} valda",
  "Selected {{count}}/{{max}} (of {{total}})": "{{count}}/{{max}} valda (av {{total}})",
  "Setup": "Setup",
  "Show": "Visa",
  "Space": "Utrymme",
  "Start date": "Startdatum",
  "Superadmin": "Superadmin",
  "Time": "Tid",
  "Title": "Titel",
  "Update": "Uppdatera",
  "User ID": "AnvändarID",
  "Variant": "Variant",
  "View": "Visa",
  "Yes": "Ja",
  "Load more": "Visa mer",
  "Load all": "Visa alla",
  "Placeholder image": "Platshållarbild",
  "Video": "Videocontent",
  "Length": "Längd",
  "Type to search...": "Börja sök...",
  "0": "noll",
  "1": "ett",
  "1_neutrum": "ett",
  "1_utrum": "en",
  "2": "två",
  "3": "tre",
  "4": "fyra",
  "5": "fem",
  "6": "sex",
  "7": "sju",
  "8": "åtta",
  "9": "nio",
  "These Terms of Use have been superseded. Follow the link to the current ones.": "Dessa användarvillkor har ersatts av nya. Följ länken till de aktuella villkoren.",
  "New Terms of Use": "Nya användarvillkor",
  "These Privacy Notes have been superseded. Follow the link to the current ones.": "Denna integritetspolicy har ersatts av en ny. Följ länken till den aktuella policyn.",
  "New Privacy Notes": "Ny integritetspolicy",
  "Updated terms": "Uppdaterade användarvillkor",
  "Move Up": "Flytta Upp",
  "Move Down": "Flytta Ner",
  "remove-item": "Är du säker på att du vill ta bort {{item}}?",
  "remove-item_plural": "Är du säker på att du vill ta bort alla {{item}}?",
  "Choose...": "Välj...",
  "Group by": "Gruppera på",
  "From": "Från",
  "To": "Till",
  "Show selected": "Visa valda",
  "Clear selection": "Rensa urval",
  "Manual": "Manuell",
  "Select date": "Välj datum",
  "Category": "Kategori",
  "Type": "Learning Type",
  "Subject": "Ämne",
  "Group": "Grupp",
  "Featured": "Utvalda",
  "Apply": "Ansök",
  "learning Items": "lärobjekt",
  "Required": "Obligatorisk",
  "Optional": "Valfri",
  "write-caption": "Write caption (optional)"
}
